import React from 'react';
import { randomUUID } from '../../../../../utils/cms';

import styles from './Video.module.scss';

const Video = React.forwardRef((props, ref) => {
    // this should be in every component, its used to forward the click event to the builder if in preview mode
    let preview_click=null;
    if (props.is_preview && props.onClick){
        preview_click = props.onClick;
    }

    const width = props?.style?.width || "560px";
    const height = props?.style?.height || "315px";

    // Show placeholder in preview mode when no video URL is set
    if (!props.video_url && props.is_preview) {
        return (
            <div
                ref={ref}
                className={`${styles.wrapper} ${styles.placeholder}`}
                style={{
                    width: width,
                    height: height,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f0f0',
                    border: '2px dashed #ccc',
                    color: '#999',
                    fontSize: '14px',
                    cursor: 'pointer'
                }}
                onClick={preview_click}
            >
                <div style={{textAlign: 'center'}}>
                    <i className="far fa-video" style={{fontSize: '48px', marginBottom: '10px', display: 'block'}}></i>
                    <div>Click to add video URL</div>
                </div>
            </div>
        );
    }

    if (!props.video_url) return null;

    return (
        <div className={styles.wrapper}>
            <iframe
                title={randomUUID()}
                ref={ref}
                src={props.video_url}
                width={width}
                height={height}
                border="0"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
                onClick={preview_click}
            />
        </div>
    );
});

export default Video;